<script lang="ts">
  const ERROR_NOTIFICATION_TIMEOUT = process.env.ERROR_NOTIFICATION_TIMEOUT as number
  let counter = 0
  let showErrorHandler = false
  let warningMsg = ''
  $: counterCopy = counter
  const onunhandledrejection = async (e) => {
    e.promise.catch((v) => {
      const message = v?.networkError?.result?.error?.message || v?.message
      const errorCode = v?.networkError?.result?.error?.code
      warningMsg = `Unexpected error: ${message}${errorCode?`(error code: ${errorCode})`:''}`
      showErrorHandler = true
    })
    const oldCounter = counter
    counter++
    window.setTimeout(() => {
      if (counterCopy <= oldCounter) {
        e.promise.catch((v) => {
          warningMsg = `App crashed: ${v.message}`
          showErrorHandler = true
        })
      } else {
        window.setTimeout(() => {
          showErrorHandler = false
        }, ERROR_NOTIFICATION_TIMEOUT)
      }
    }, 500)
  }

  function refreshWidget() {
    location.reload()
  }
</script>

<svelte:window on:unhandledrejection={onunhandledrejection} />
<div class="container error-handler" id="error-handler">
  {#if showErrorHandler}
    <p data-test="error-handler">{warningMsg}</p>
    <p data-test="error-handler-button">
      You can click this button to refresh the widget: <button
        class="error-handler-button"
        data-test="refresh-login"
        on:click={refreshWidget}>Refresh</button>
    </p>
  {/if}
</div>

<style>
  .error-handler {
    color: red;
  }

  .error-handler-button {
    background-color: white;
    border: 1px solid red;
    cursor: pointer;
    font-size: 12px;
    line-height: 22px;
    margin: 0;
    margin-right: 16px;
    padding: 0;
    color: red;
  }
</style>
